import Vue from 'vue';
import { managerService } from '../../services/manager.service';

const state = {
  apps: {},
  activeApp: null,
  appsDetails: {}
};

const mutations = {
  SET_APPS(state, apps) {
    state.apps = apps;
  },
  
  SET_ACTIVE_APP(state, payload) {
    state.activeApp = payload;
  },
  
  SET_APPS_DETAILS(state, payload) {
    // Convert to array, sort alphabetically by appname, then convert back to object
    const sortedApps = Object.entries(payload)
      .sort(([, a], [, b]) => {
        const aName = (a.appname || '').toLowerCase();
        const bName = (b.appname || '').toLowerCase();
        return aName.localeCompare(bName);
      })
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});
    
    state.appsDetails = sortedApps;
  }
};

const actions = {
  async fetchApps({ commit }) {
    try {	
      const appsResponse = await managerService.fetchApps();
      console.log(appsResponse.data.result, 'apps');
      commit('SET_APPS', appsResponse.data.result);
      
      const appsDetailsResponse = await managerService.fetchAppsDetails();
      console.log(appsDetailsResponse.data.result, 'apps details');
      commit('SET_APPS_DETAILS', appsDetailsResponse.data.result);
    } catch (error) {
      console.error('Error fetching apps: ', error);
    }
  },

  setActiveApp({ state, commit, dispatch }, payload) {
    console.log("Attempting to change active app settings with: ", payload);
    console.log("Current active app:", state.activeApp, "New app:", payload);
    
    // Don't change if it's the same app
    if (state.activeApp === payload) {
      console.log("No change needed - activeApp already set to:", payload);
      return;
    }
    
    // Don't change if payload is null/undefined/empty
    if (!payload) {
      console.log("Ignoring empty payload for setActiveApp");
      return;
    }
    
    // Set the new active app
    commit('SET_ACTIVE_APP', payload);
    console.log("Successfully changed active app to:", payload);
  }
};

const getters = {
  apps(state) {
    let apps = state.apps;
    const sortedObj = Object.fromEntries(
      Object.entries(apps).sort(([, val1], [, val2]) => val1.localeCompare(val2))
    );
    return sortedObj;
  },
  
  activeApp: state => state.activeApp,
  
  appsDetails: state => state.appsDetails || {}
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

